import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// 이미지 임포트 (실제 경로에 맞게 수정하세요)
import bg1 from '../assets/images/slidebg1.jpg';
import bg2 from '../assets/images/slidebg2.jpg';
import bg3 from '../assets/images/slidebg3.jpg';

const images = [bg1, bg2, bg3];

export default function BackgroundSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // 5초 간격

    return () => clearInterval(intervalId);
  }, []);

  // 슬라이드 애니메이션 설정
  const variants = {
    enter: {
      x: '100%',
      opacity: 1, // 시작부터 완전히 보임
      zIndex: 1, // 새로운 이미지가 기존 이미지 위에 오도록
    },
    // 현재 이미지 (중앙에 위치)
    center: {
      x: '0%',
      opacity: 1, // 완전히 보임
      zIndex: 0, // 기본 z-index
    },
    // 이전 이미지가 왼쪽 밖으로 나감
    exit: {
      x: '-100%',
      opacity: 1, // 사라질 때까지 완전히 보임
      zIndex: 0, // 기본 z-index
    },
  };

  return (
    <div className="relative w-full h-[600px] overflow-hidden">
      <AnimatePresence initial={false}>
        <motion.div
          key={currentIndex}
          className="absolute top-0 left-0 w-full h-full"
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ duration: 1, ease: 'easeInOut' }}
        >
          {/* 이미지 */}
          <img
            src={images[currentIndex]}
            alt={`배경 이미지 ${currentIndex + 1}`}
            className="w-full h-full object-cover"
          />

          {/* 오버레이 레이어 */}
          <div className="absolute inset-0 bg-black opacity-50"></div>
        </motion.div>
      </AnimatePresence>

      {/* 텍스트 콘텐츠 */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <h1 className="text-3xl sm:text-4xl md:text-5xl text-white font-bold mb-[100px]">
          건강한 삶을 위한 당신의 선택
        </h1>
        <p className="text-sm sm:text-base md:text-lg text-white leading-relaxed">
          관절 건강을 위해 자연에서 온 보조제
          <br />
          우리 몸이 균형을 찾게 도와줍니다
        </p>
      </div>
      {/* 슬라이드 인디케이터 */}
      <div className="absolute bottom-[10px] left-1/2 transform -translate-x-1/2 z-20 flex space-x-3">
        {images.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentIndex(idx)}
            className={`w-3 h-3 rounded-full transition-colors ${
              idx === currentIndex ? 'bg-white' : 'bg-white/50'
            }`}
            aria-label={`슬라이드 ${idx + 1} 보기`}
          />
        ))}
      </div>
    </div>
  );
}
